import { BaseSerializer } from './base.serializer'
import { HubRegistration } from 'models/hub-registration.model'
import { DateSerializer, TimeSerializer } from './attributes'

import { HubRegistrationInfraction } from 'models'
import { InfractionSerializer } from './infraction.serializer'


// Сериалайзер нарушений в интервью
export class HubRegistrationInfractionSerializer extends BaseSerializer<HubRegistrationInfraction> {


  static DESERIALIZERS = {
    infraction: InfractionSerializer
  }

  static initializeObject(attributes: Object): HubRegistrationInfraction {
    return new HubRegistrationInfraction(attributes)
  }
}


export class HubRegistrationSerializer extends BaseSerializer<HubRegistration> {
  static SERIALIZABLE_ATTRIBUTES = [
    'id', 'hubId', 'cityId', 'licenseNumber', 'firstName', 'lastName', 'middleName', 'phone', 
    'course', 'scheduledAt', 'ack', 'nowTime', 'createdAt', 'hubRegistrationInfractions', 
    'hubTimeIntervalId', 'hubCourseId', 'source', 'locale', 'country', 'centerId'
  ]


  static SERIALIZERS = {
    scheduledAt: TimeSerializer
  }

  static SERIALIZE_RENAME_KEYS = {}


  static DESERIALIZERS = {
    createdAt: TimeSerializer,
    scheduledAt: TimeSerializer,
    hubRegistrationInfractions: HubRegistrationInfractionSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}


  static initializeObject(attributes: Object): HubRegistration {
    return new HubRegistration(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/hub-registration.serializer.ts